import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { AppState } from 'src/app/store/app.state';

export interface ActivityCommentModel {
  id?: any;
  activityID?: any;
  orgID?: any;
  content?: string;
  creatorID?: any;
  creatorName?: string;
  createdDate?: string;
  createdDateTimestamp?: any;
  clientID?: string;
  otherID?: string;
  otherName?: string;
  dealCode?: string;
  mentionedUserIDs?: string[];
  mentionedUserNames?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ActivityCommentService {

  private analyticsUrl = this.endpoint.analyticsUrl;
  orgID;
  user;

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>
  ) {
    store.select('userInfo').subscribe((info) => {
      this.orgID = info.organization.id;
      this.user = info.user;
    });
  }

  /**
   * Add a comment to an activity
   * @param form the activity context plus the comment content
   */
  addComment(form: ActivityCommentModel) {
    const body = {
      activityID: `${form.activityID}`,
      orgID: `${this.orgID}`,
      content: `${form.content}`,
      creatorID: `${form.creatorID || this.user.id}`,
      creatorName: `${form.creatorName || (this.user.firstName + ' ' + this.user.lastName)}`,
      clientID: `${form.clientID || ''}`,
      otherID: `${form.otherID || ''}`,
      otherName: `${form.otherName || ''}`,
      dealCode: `${form.dealCode || ''}`,
      // Mention arrays travel as arrays: the server resolves/dedupes the names itself.
      mentionedUserIDs: Array.isArray(form.mentionedUserIDs) ? form.mentionedUserIDs : [],
      mentionedUserNames: Array.isArray(form.mentionedUserNames) ? form.mentionedUserNames : []
    };
    return this.http.post(`${this.analyticsUrl}/addActivityComment`, body)
      .pipe(map((res: any) => res && res.data ? res.data : null));
  }

  /**
   * Fetch the comment thread of an activity, oldest first
   * @param activityID
   */
  getComments(activityID): Observable<any[]> {
    return this.http.get(`${this.analyticsUrl}/getActivityComments/${activityID}`)
      .pipe(
        map((res: any) => res && res.data ? res.data : []),
        catchError(() => of([]))
      );
  }
}
